module.exports = __webpack_public_path__ + "img/sjfxpt.6279366d.png";